import { LOGIN_CARD_BODY_CLASS, LoginCard } from "./login/LoginCard";

import { Link } from "react-router-dom";
import { PROVIDER_PORTAL_MAIN_COLUMN_CLASS } from "./util/providerPortalMainColumn";
import { ReactNode } from "react";
import { rebrandEnabled } from "./util/brandingFlag";

/** Magic-link confirmation, plus the expired and invalid-email variants. */
const CheckYourEmail = () => {
  const rebrand = rebrandEnabled();
  const query = new URLSearchParams(window.location.search);
  const invalidEmail = query.get("invalid_email");
  const expired = query.get("expired");

  const loginLink = (
    <Link
      to="/login?type=provider"
      className={rebrand ? "tw-text-verse-text-brand tw-underline" : undefined}
    >
      Log In
    </Link>
  );

  let heading = "Almost there! We've emailed you a sign-in link.";
  let body: ReactNode =
    "Please click on the link from us in your email to sign in instantly.";
  if (expired) {
    heading = "This link has expired";
    body = (
      <>
        This link is no longer valid. Return to the {loginLink} page to request
        a new sign-in link.
      </>
    );
  } else if (invalidEmail) {
    heading = "That doesn't look right. Please try again.";
    body = (
      <>
        You've entered an invalid email. Return to the {loginLink} page and
        enter the correct email to proceed.
      </>
    );
  }

  if (rebrand) {
    return (
      <LoginCard heading={heading}>
        <p className={LOGIN_CARD_BODY_CLASS}>{body}</p>
      </LoginCard>
    );
  }

  return (
    <div className={PROVIDER_PORTAL_MAIN_COLUMN_CLASS} id="terms_page">
      <h2 className="check-your-email-heading">{heading}</h2>
      <div className="check-your-email-text">{body}</div>
    </div>
  );
};

export default CheckYourEmail;
